import { ReactNode } from 'react';

import {
  ScrollableDialogContent,
  ShadowDivider,
  Typography,
  Stack,
  colorOrToken,
  tokens,
} from '@cast/design-system';

type Props = {
  left: ReactNode;
  leftTitle: string;
  right: ReactNode;
  rightTitle: ReactNode;
};

export const FeaturesScriptSplitDialogContent = ({
  left,
  leftTitle,
  right,
  rightTitle,
}: Props) => {
  return (
    <ScrollableDialogContent sx={{ pb: 0, px: 0 }}>
      <Stack direction="row">
        <Stack flex={1} minWidth={0} py={16} px={24}>
          <Typography variant="h6" mb={2}>
            {leftTitle}
          </Typography>
          {left}
        </Stack>
        <Stack
          width={440}
          flexShrink={0}
          py={16}
          px={24}
          bgcolor={colorOrToken('grey.100', tokens.theme.bg.structural.page)}
          position="relative"
        >
          <ShadowDivider absolute top left right />
          {typeof rightTitle === 'string' ? (
            <Typography variant="h6" mb={2}>
              {rightTitle}
            </Typography>
          ) : (
            rightTitle
          )}
          {right}
        </Stack>
      </Stack>
    </ScrollableDialogContent>
  );
};
